const WageTypeDisplay = ({ wageType, hourlyWageType, t }) => {
    if (!wageType?.label && !hourlyWageType?.label) return null;
    // Only label "Fixed Salary" when there's an Hourly value to distinguish it from - a single
    // configured value (Fixed only) is the default for everyone, so labelling it "Fixed Salary" alone would be misleading.
    const bothConfigured = !!(wageType?.label && hourlyWageType?.label);
    return (
        <div>
            {wageType?.label && <div>{wageType.label}{bothConfigured ? ` (${t('Fixed Salary')})` : ''}</div>}
            {hourlyWageType?.label && <div>{hourlyWageType.label} ({t('Hourly')})</div>}
        </div>
    );
};

export default WageTypeDisplay;
